import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import { get } from 'lodash';

const DefinedInvestmentStyle = ({ classes, dealInterest }) => {
  if (get(dealInterest, 'inventory_user.user')) {
    return (
      <div className={classes.status}>
        <strong><FormattedMessage id="profile_page.defined_investment_style"/></strong>
        <p>{get(dealInterest, 'inventory_user.user.defined_investment_style') ? <FormattedMessage id="profile_page.yes_discretionary_investment_models"/>  : <FormattedMessage id="profile_page.no_discretionary_investment_models"/>}</p>
      </div>
    );
  }
  return <div />;
};

const styles = {
  status : {
    margin : '0px 0px 15px 25px',
    width  : 170,
  },
};

export default withStyles(styles)(DefinedInvestmentStyle);
